<div class="full-width">
  <div
    class="input-container"
    [class.disabled]="disabledState$ | async"
  >
    <div #inputArea></div>
  </div>
</div>
